import React, { Fragment, useEffect, useRef, useState } from "react";
import localization from "assets/localization/localization";
import PanelCardWithHeading from "components/tickets/panelCardWithHeading";
import Layout from "components/sales/layout/layout";
import SiteInformationForm from "components/fileComplain/formSection/siteInformationForm/valetFilter";
import ConstantInput from "../../../components/sales/Input/constantInput/constantInput";
import Checkbox from "components/sales/Input/checkbox/checkbox";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { toast } from "react-toastify";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import imageCompression from "browser-image-compression";
import TableSection from "../../../components/sales/tableSection/tableSection";
import CardSection from "components/sales/cardSection/cardSection";

const InternalCommunication = ({
  documentUploadUrlPublic,
  documentUrlDataPublic,
  contactList = [],
  projectsList = [],
  notificationData = [],
  getContactsList,
  getProjectsList,
  sendNotification,
  getNotificationUser,
  broadcastNotificationUserList = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [listData, setListData] = useState([]);
  const [attachment, setAttachment] = useState("");
  const [attachmentCSV, setAttachmentCSV] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [inputList, setInputList] = useState([
    {
      heading: "",
      sub_heading: "",
      video_url: [],
      image_urls: [],
      audio_urls: [],
    },
  ]);
  const [selectedUserIds, setSelectedUserIds] = useState([]); // State to handle selected phone numbers
  const [phoneNumbersList, setPhoneNumbersList] = useState([]); // State to handle the fetched and formatted contact list
  const [selectedCities, setSelectedCities] = useState([]); // State to handle selected phone numbers
  const [projectList, setProjectList] = useState([]); // State to handle the fetched and formatted contact list
  const [selectedProjects, setSelectedProjects] = useState([]); // State to handle selected phone numbers

  // const [isRecording, setIsRecording] = useState(false);
  // const [audioURL, setAudioURL] = useState(null);
  // const [audioBlob, setAudioBlob] = useState(null);
  // const mediaRecorderRef = useRef(null);
  const [audio, setAudio] = useState(null);
  // const audioChunks = useRef([]);
  // const [fileName, setFileName] = useState('');

  // const [showFileName, setShowFileName] = useState(false);
  // const [multiple, setmultiple] = useState(false);

  // const [base64Url, setbase64Url] = useState();
  // const [addedFiles, setAddedFiles] = useState([]);
  // const [isBase64, setIsBase64] = useState(true);

  // const startRecording = async () => {
  //     // Request permission to access the microphone
  //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //     console.log(stream)

  //     // Create a new MediaRecorder instance
  //     mediaRecorderRef.current = new MediaRecorder(stream);
  //     setIsRecording(true);
  //     console.log(mediaRecorderRef)

  //     if (!Array.isArray(audioChunks.current)) {
  //       audioChunks.current = [];
  //     }
  //     // Event handler for data available
  //     mediaRecorderRef.current.ondataavailable = (event) => {
  //       audioChunks.current.push(event.data);
  //     };
  // console.log(audioChunks)
  //     // Event handler when recording is stopped
  //     mediaRecorderRef.current.onstop = () => {
  //       console.log(audioChunks.current)
  //       const audioBlob = new Blob(audioChunks.current, { type: "audio/wav" });
  //       console.log(audioBlob)
  //       const audioURL = URL.createObjectURL(audioBlob);
  //       console.log(audioURL)
  //       setAudioURL(audioURL);
  //       setAudioBlob(audioBlob);
  //       audioChunks.current = [];
  //     };

  //     // Start recording
  //     mediaRecorderRef.current.start();
  //   };

  //   const stopRecording = () => {
  //     mediaRecorderRef.current.stop();
  //     setIsRecording(false);
  //   };

  //   const deleteRecording = () => {
  //     setAudioURL(null);
  //     setAudioBlob(null);
  //   };

  //   const handleSaveAudio = (event) => {
  //     let val = audio;
  //   };

  const handleInputList = (val, key) => {
    let list = [...inputList];
    list[0][key] = val;
    setInputList(list);
  };
  const [hasManpowerPhoneNumber, setHasManpowerPhoneNumber] = useState(null);

  const handleRadioChange = (event) => {
    setHasManpowerPhoneNumber(event.target.value === "yes");
  };

  const handleSubmitNotification = async () => {
    inputList["attachment"] = attachment;
    inputList["audio"] = audio;
    if (
      inputList[0].heading == null ||
      inputList[0].heading == undefined ||
      inputList[0].heading == ""
    ) {
      toast.error("Heading is required");
      return;
    }
    if (
      inputList[0].sub_heading == null ||
      inputList[0].sub_heading == undefined ||
      inputList[0].sub_heading == ""
    ) {
      toast.error("Sub Heading is required");
      return;
    }
    const urlRegex = /https?:\/\/[^\s]+/g;
    // Check if there's exactly one URL
    if (
      inputList[0].video_url[0] != null &&
      inputList[0].video_url[0] != undefined &&
      inputList[0].video_url[0] != ""
    ) {
      const matchedUrls = inputList[0].video_url[0].match(urlRegex);
      if (matchedUrls == null) {
        toast.error("Please enter exactly one valid URL.");
        return;
      }
    }
    if (attachment.length > 3) {
      toast.error("More than 3 Images are not allowed");
      return;
    }
    // if(attachment.length==0 && audio.length == 0 && (inputList[0].video_url[0]==null || inputList[0].video_url[0]==undefined || inputList[0].video_url[0]=='')){
    //   toast.error('Ateast one of Video, Image or Audio is required');
    //   return;
    // }
    if (
      hasManpowerPhoneNumber === false &&
      selectedProjects.length == 0 &&
      selectedCities.length == 0
    ) {
      toast.error("Select alteast one of cities or projects");
      return;
    }
    if (hasManpowerPhoneNumber === true && selectedUserIds.length == 0) {
      toast.error("Atleast one contact is required");
      return;
    }
    const dataToSend = {
      user_ids: selectedUserIds,
      project_ids: selectedProjects,
      cities: selectedCities,
      user_data: attachmentCSV,
      data: {
        title: inputList[0].heading,
        desc: inputList[0].sub_heading,
        photo_urls: attachment.length > 0 ? attachment : [], // Ensure it's an array
        audio_urls: audio.length > 0 ? [audio] : [], // Ensure it's an array
        video_urls: inputList[0].video_url ? inputList[0].video_url : [],
      },
    };

    setIsLoading(true);
    const response = await sendNotification(dataToSend);
    if (response) {
      toast.success("Notification created successfully");
      setIsLoading(false);
      setIsDisabled(true);

      setTimeout(() => {
        setIsDisabled(false);
        window.location.reload();
      }, 4000);
    } else {
      setIsLoading(false);
      toast.warning("Not Saved.");
      return false;
    }
  };

  const fetchContactList = async () => {
    setIsLoading(true); // Start loading
    const res = await getContactsList(); // Fetch contacts
    setIsLoading(false); // End loading

    if (res) {
      // Format fetched data
      // const formattedData = res.resultSets.map((contact) => ({
      //   value: contact.name,
      //   name: `${contact.phone_number}-${contact.name}`,
      // }));

      return res.resultSets; // Return formatted data for DropDownInput
    } else {
      return []; // Return empty array if no data is fetched
    }
  };

  const fetchProjectList = async () => {
    setIsLoading(true); // Start loading
    const res = await getProjectsList(); // Fetch contacts
    setIsLoading(false); // End loading

    if (res) {
      // Format fetched data
      return res; // Return formatted data for DropDownInput
    } else {
      return []; // Return empty array if no data is fetched
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchContactList(); // Call the function to fetch and format the data
      setPhoneNumbersList(data); // Set the formatted data in state
      const projectData = await fetchProjectList(); // Call the function to fetch and format the data
      setProjectList(projectData); // Set the formatted data in state
    };

    fetchData(); // Invoke the fetchData function
  }, []);

  const handleUserList = async () => {
    inputList["attachment"] = attachment;
    inputList["audio"] = audio;
    if (
      inputList[0].heading == null ||
      inputList[0].heading == undefined ||
      inputList[0].heading == ""
    ) {
      toast.error("Heading is required");
      return;
    }
    if (
      inputList[0].sub_heading == null ||
      inputList[0].sub_heading == undefined ||
      inputList[0].sub_heading == ""
    ) {
      toast.error("Sub Heading is required");
      return;
    }
    const urlRegex = /https?:\/\/[^\s]+/g;
    // Check if there's exactly one URL
    if (
      inputList[0].video_url[0] != null &&
      inputList[0].video_url[0] != undefined &&
      inputList[0].video_url[0] != ""
    ) {
      const matchedUrls = inputList[0].video_url[0].match(urlRegex);
      if (matchedUrls == null) {
        toast.error("Please enter exactly one valid URL.");
        return;
      }
    }
    if (attachment.length > 3) {
      toast.error("More than 3 Images are not allowed");
      return;
    }
    // if(attachment.length==0 && audio.length == 0 && (inputList[0].video_url[0]==null || inputList[0].video_url[0]==undefined || inputList[0].video_url[0]=='')){
    //   toast.error('Ateast one of Video, Image or Audio is required');
    //   return;
    // }
    if (
      hasManpowerPhoneNumber === false &&
      selectedProjects.length == 0 &&
      selectedCities.length == 0
    ) {
      toast.error("Select alteast one of cities or projects");
      return;
    }
    if (hasManpowerPhoneNumber === true && selectedUserIds.length == 0) {
      toast.error("Atleast one contact is required");
      return;
    }
    const dataToSend = {
      user_ids: selectedUserIds,
      project_ids: selectedProjects,
      cities: selectedCities,
      user_data: attachmentCSV,
      page: 1,
      data: {
        title: inputList[0].heading,
        desc: inputList[0].sub_heading,
        photo_urls: attachment.length > 0 ? attachment : [], // Ensure it's an array
        audio_urls: audio.length > 0 ? [audio] : [], // Ensure it's an array
        video_urls: inputList[0].video_url ? inputList[0].video_url : [],
      },
    };

    setIsLoading(true);
    await getNotificationUser(dataToSend);
    setIsLoading(false);
  };
//   const headerBtns = () => {
//     return (
//       <>
//         <Fragment>
//           <a
//             href={`#`}
//             className="btn btn-primary d-none d-md-inline-block"
//             onClick={handleUserList}
//           >
//             User Notification List
//           </a>
//         </Fragment>
//       </>
//     );
//   };

  const Headers = ["User Id", "User Name", "Phone Number"];

  useEffect(() => {
    const tableData = ["user_id", "user_name", "phone_number"];

    setListData();
    if (broadcastNotificationUserList) {
      const data = broadcastNotificationUserList?.resultSets?.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          }))
        )
      );
      data && setListData(data);
      setPageCount(
        Math.ceil(broadcastNotificationUserList?.total / broadcastNotificationUserList?.per_page)
      );
    }
  }, [broadcastNotificationUserList]);

  const onPageChange = async (val) => {
    const dataToSend = {
      user_ids: selectedUserIds,
      project_ids: selectedProjects,
      cities: selectedCities,
      user_data: attachmentCSV,
      page: val.selected + 1,
      data: {
        title: inputList[0].heading,
        desc: inputList[0].sub_heading,
        photo_urls: attachment.length > 0 ? attachment : [], 
        audio_urls: audio.length > 0 ? [audio] : [], 
        video_urls: inputList[0].video_url ? inputList[0].video_url : [],
      },
    };
    setIsLoading(true);
    await getNotificationUser(dataToSend);
    setIsLoading(false);
};

console.log("broadcastNotificationUserList", broadcastNotificationUserList)

  return (
    <>
      <Layout
        title={localization.notificationBroadcastCentre}
        isLoading={isLoading}
        isGoback={true}
      >
        <CardSection title="Notification Centre">
        <div className="card-body bg-white">
            <div className="row mt-3">
                <h5>Add Message To Send</h5>
            </div>
            <div className="row mt-3">
                <div className="col-md-4">
                    <ConstantInput
                        label={"Heading"}
                        value={""}
                        type="text"
                        handleChange={(val) => handleInputList(val, "heading")}
                        required={true}
                        isStarRequired={true}
                        maxLength={80}
                    />
                </div>
                <div className="col-md-4">
                    <ConstantInput
                        label={"Sub-Heading"}
                        value={""}
                        type="text"
                        handleChange={(val) => handleInputList(val, "sub_heading")}
                        required={true}
                        isStarRequired={true}
                        maxLength={150}
                    />
                </div>
                <div className="col-md-4">
                    <ConstantInput
                        label={"Video URL"}
                        value={""}
                        type="text"
                        handleChange={(val) => handleInputList([val], "video_url")}
                    />
                </div>
            </div>
            <div className="col-md-4">
                <FileUpload
                    id={"addAttachment"}
                    accept=".png,.jpg,.jpeg"
                    documentUploadUrl={documentUploadUrlPublic}
                    documentUrlData={documentUrlDataPublic}
                    onChange={(val) => setAttachment(val)}
                    multiple={true}
                    className="btn btn-sm"
                >
                    <span className="btn btn-transparent">
                    {"Image Attachments"}
                    </span>
                </FileUpload>
            </div>
            <div className="col-md-4">
                <FileUpload
                id={"addAttachment2"}
                accept=".mp3,.wav"
                documentUploadUrl={documentUploadUrlPublic}
                documentUrlData={documentUrlDataPublic}
                onChange={(val) => setAudio(val)}
                className="btn btn-sm"
                >
                <span className="btn btn-transparent">{"Audio Attachment"}</span>
                </FileUpload>
            </div>
            <div className="row mt-5">
                <h5>Select Recipients</h5>
            </div>
            <div className="row mt-4">
                <div className="col-md-6">
                    <DropDownInput
                    label={"Manpower Phone number"}
                    data={phoneNumbersList}
                    isStarRequired={true}
                    errorMsg={"Manpower phone number is required"}
                    multipule={true}
                    getIdValue={(val) => {
                        const userIds =
                        val.length > 0 ? val.map((user) => user.id) : [];
                        setSelectedUserIds(userIds);
                    }}
                    value={""}
                    />
                </div>
                <div className="col-md-6">
                    <DropDownInput
                    label={"Select Cities"}
                    data={[
                        { id: "Noida", name: "Noida" },
                        { id: "DELHI", name: "DELHI" },
                        { id: "mumbai", name: "mumbai" },
                        { id: "Gurgaon", name: "Gurgaon" },
                        { id: "Bangalore", name: "Bangalore" },
                        { id: "Gurugram", name: "Gurugram" },
                        { id: "Ghaziabad", name: "Ghaziabad" },
                        { id: "Hyderabad", name: "Hyderabad" },
                        { id: "Pune", name: "Pune" },
                        { id: "Bengaluru", name: "Bengaluru" },
                        { id: "Chennai", name: "Chennai" },
                        { id: "Thane Mumbai", name: "Thane Mumbai" },
                        { id: "Rangareddy", name: "Rangareddy" },
                        { id: "Greater Mumbai", name: "Greater Mumbai" },
                        { id: "Thane", name: "Thane" },
                        { id: "Faridabad", name: "Faridabad" },
                        { id: "Greater Noida", name: "Greater Noida" },
                        { id: "Jaipur", name: "Jaipur" },
                        { id: "Kancheepuram", name: "Kancheepuram" },
                        { id: "dehradun", name: "dehradun" },
                        { id: "LUCKNOW", name: "LUCKNOW" },
                        { id: "NAINITAL", name: "NAINITAL" },
                    ]}
                    multipule={true}
                    getIdValue={(val) => {
                        const cities = val.length > 0 ? val.map((city) => city.id) : [];
                        setSelectedCities(cities);
                    }}
                    value={""}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <DropDownInput
                    label={"Select Project"}
                    data={projectList}
                    multipule={true}
                    getIdValue={(val) => {
                        const projectIds =
                        val.length > 0 ? val.map((project) => project?.id) : [];
                        setSelectedProjects(projectIds);
                    }}
                    value={""}
                    />
                </div>
                <FileUpload
                    id={"addAttachment3"}
                    accept=".csv"
                    documentUploadUrl={documentUploadUrlPublic}
                    documentUrlData={documentUrlDataPublic}
                    onChange={(val) => setAttachmentCSV(val)}
                >
                <span className="btn btn-transparent">{"Upload CSV"}</span>
                </FileUpload>
            </div>
            <div className="row">
          
            <div className="row d-flex mt-4" style={{justifyContent: 'space-between'}}>
                <button
                    href={`#`}
                    className="btn btn-primary"
                    onClick={handleUserList}
                >
                    Get Recipients List
                </button>
                <button
                    className="btn btn-primary"
                    disabled={isDisabled}
                    onClick={handleSubmitNotification}
                    >
                    Send Notification
                </button>
            </div>
        </div>
        </div>
        </CardSection>
        {/* <div className="col-md-6">*/}
        {/*    <fieldset className="mb-12">*/}
        {/*    <legend className="col-form-label">Manpower Phone Number</legend>*/}
        {/*    */}
        {/*    <div className="form-check col-md-6">*/}
        {/*        <input*/}
        {/*        className="form-check-input"*/}
        {/*        type="radio"*/}
        {/*        id="phoneYes"*/}
        {/*        value="yes"*/}
        {/*        checked={hasManpowerPhoneNumber === true}*/}
        {/*        onChange={handleRadioChange}*/}
        {/*        />*/}
        {/*        <label className="form-check-label" htmlFor="phoneYes">*/}
        {/*        Yes*/}
        {/*        </label>*/}
        {/*    </div>*/}
        {/*    <div className="form-check col-md-6">*/}
        {/*        <input*/}
        {/*        className="form-check-input"*/}
        {/*        type="radio"*/}
        {/*        id="phoneNo"*/}
        {/*        value="no"*/}
        {/*        checked={hasManpowerPhoneNumber === false}*/}
        {/*        onChange={handleRadioChange}*/}
        {/*        />*/}
        {/*        <label className="form-check-label" htmlFor="phoneNo">*/}
        {/*        No*/}
        {/*        </label>*/}
        {/*    </div>*/}
        {/*    </fieldset>*/}
        {/*</div>*/}
        
          {/*<div className="col-md-6">*/}
          {/*    /!*{hasManpowerPhoneNumber === true && (*!/*/}
          {/*    <div className="col-md-6">*/}
          {/*        <DropDownInput*/}
          {/*            label={'Manpower Phone number'}*/}
          {/*            data={phoneNumbersList} // Assign the fetch function directly*/}
          {/*            isStarRequired={true}*/}
          {/*            errorMsg={'Manpower phone number is required'}*/}
          {/*            multipule={true}*/}
          {/*            getIdValue={(val) => {*/}
          {/*                const userIds = val.length > 0 ? val.map(user => user.id) : [];*/}
          {/*                setSelectedUserIds(userIds)*/}
          {/*                // setSelectedPhoneNumbers([...selectedPhoneNumbers, val?.value]);*/}

          {/*            }} // Use the handler function*/}
          {/*            value={''} // Set selected value from state*/}
          {/*        />*/}
          {/*    </div>*/}
          {/*    /!*)}*!/*/}

          {/*    {hasManpowerPhoneNumber === false && (*/}
          {/*        <>*/}
          {/*            <div className="col-md-6">*/}
          {/*                <DropDownInput*/}
          {/*                    label={'Select Cities'}*/}
          {/*                    data={[*/}
          {/*                        {id: 'Noida', name: 'Noida'},*/}
          {/*                        {id: 'DELHI', name: 'DELHI'},*/}
          {/*                        {id: 'mumbai', name: 'mumbai'},*/}
          {/*                        {id: 'Gurgaon', name: 'Gurgaon'},*/}
          {/*                        {id: 'Bangalore', name: 'Bangalore'},*/}
          {/*                        {id: 'Gurugram', name: 'Gurugram'},*/}
          {/*                        {id: 'Ghaziabad', name: 'Ghaziabad'},*/}
          {/*                        {id: 'Hyderabad', name: 'Hyderabad'},*/}
          {/*                        {id: 'Pune', name: 'Pune'},*/}
          {/*                        {id: 'Bengaluru', name: 'Bengaluru'},*/}
          {/*                        {id: 'Chennai', name: 'Chennai'},*/}
          {/*                        {id: 'Thane Mumbai', name: 'Thane Mumbai'},*/}
          {/*                        {id: 'Rangareddy', name: 'Rangareddy'},*/}
          {/*                        {id: 'Greater Mumbai', name: 'Greater Mumbai'},*/}
          {/*                        {id: 'Thane', name: 'Thane'},*/}
          {/*                        {id: 'Faridabad', name: 'Faridabad'},*/}
          {/*                        {id: 'Greater Noida', name: 'Greater Noida'},*/}
          {/*                        {id: 'Jaipur', name: 'Jaipur'},*/}
          {/*                        {id: 'Kancheepuram', name: 'Kancheepuram'},*/}
          {/*                        {id: 'dehradun', name: 'dehradun'},*/}
          {/*                        {id: 'LUCKNOW', name: 'LUCKNOW'},*/}
          {/*                        {id: 'NAINITAL', name: 'NAINITAL'}*/}
          {/*                    ]*/}
          {/*                    }*/}
          {/*                    multipule={true}*/}

          {/*                    getIdValue={(val) => {*/}
          {/*                        const cities = val.length > 0 ? val.map(city => city.id) : [];*/}
          {/*                        setSelectedCities(cities)*/}
          {/*                    }*/}
          {/*                    }*/}
          {/*                    value={''}*/}
          {/*                />*/}
          {/*            </div>*/}
          {/*            <div className="col-md-6">*/}
          {/*                <DropDownInput*/}
          {/*                    label={'Select Project'}*/}
          {/*                    data={projectList}*/}
          {/*                    multipule={true}*/}
          {/*                    getIdValue={(val) => {*/}
          {/*                        const projectIds = val.length > 0 ? val.map(project => project?.id) : [];*/}
          {/*                        setSelectedProjects(projectIds);*/}
          {/*                    }}*/}
          {/*                    value={''}*/}
          {/*                />*/}
          {/*            </div>*/}
          {/*        </>*/}

          {/*    )}*/}
          {/*</div>*/}
        {/* <TableSection 
          data={listData} 
          headers={Headers} 
          isId={false} 
        /> */}
          <TableSection
            data={listData}
            isId={true}
            headers={Headers}
            pageCount={pageCount}
            srNo={broadcastNotificationUserList?.from}
            onPageChange={onPageChange}
          />
      </Layout>
    </>
  );
};

export default InternalCommunication;
